var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timezone-picker-section" },
    [
      _c("div", { staticClass: "sectionTitle" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "a-popover",
        {
          attrs: { visible: _vm.visible, overlayClassName: "no-padding" },
          on: {
            visibleChange: function (_visible) {
              return (_vm.visible = false)
            },
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("TimezonePicker", {
                model: {
                  value: _vm.clone,
                  callback: function ($$v) {
                    _vm.clone = $$v
                  },
                  expression: "clone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "entity-input" }, [
            _c(
              "div",
              { staticClass: "entity-input-text-wrapper" },
              [
                _c("TiptapEditor", {
                  key: _vm.clone,
                  attrs: {
                    placeholder: _vm.title,
                    "show-attributes": true,
                    "show-emoji": false,
                    "automation-mode": "",
                  },
                  model: {
                    value: _vm.clone,
                    callback: function ($$v) {
                      _vm.clone = $$v
                    },
                    expression: "clone",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "material-icons",
                on: {
                  click: function ($event) {
                    _vm.visible = !_vm.visible
                  },
                },
              },
              [_vm._v(" expand_more ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }